export default "__VITE_ASSET__Dng6xzmN__"